import {
  ADD_MODULE_FAILURE,
  ADD_MODULE_REQUEST,
  ADD_MODULE_SUCCESS,
  GET_MODULES_BY_COURSE_ID_FAILURE,
  GET_MODULES_BY_COURSE_ID_REQUEST,
  GET_MODULES_BY_COURSE_ID_SUCCESS,
  RESET_MODULE_APPROVAL_STATUS,
  UPDATE_MODULE_APPROVAL_STATUS_FAILURE,
  UPDATE_MODULE_APPROVAL_STATUS_REQUEST,
  UPDATE_MODULE_APPROVAL_STATUS_SUCCESS,
  GET_MODULE_BY_ID_REQUEST,
  GET_MODULE_BY_ID_SUCCESS,
  GET_MODULE_BY_ID_FAILURE,
  UPDATE_MODULE_ORDER_REQUEST,
  UPDATE_MODULE_ORDER_SUCCESS,
  UPDATE_MODULE_ORDER_FAILURE,
  UPDATE_MODULE_REQUEST,
  UPDATE_MODULE_SUCCESS,
  UPDATE_MODULE_FAILURE,
  DELETE_MODULE_REQUEST,
  DELETE_MODULE_SUCCESS,
  DELETE_MODULE_FAILURE,
} from "./ActionType";

const initialState = {
  module: null,
  moduleListReponse: {},
  moduleApprovalStatusChangeResponse: {},
  moduleByIdResponse: {},
  isLoading: false,
  error: null,
  updateOrderLoading: false,
  updateOrderError: null,
  updateModuleLoading: false,
  updateModuleError: null,
  updateModuleResult: null,
  deleteModuleLoading: false,
  deleteModuleError: null,
  deleteModuleResult: null,
};
export const moduleReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_MODULE_REQUEST:
    case GET_MODULES_BY_COURSE_ID_REQUEST:
    case UPDATE_MODULE_APPROVAL_STATUS_REQUEST:
    case GET_MODULE_BY_ID_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case ADD_MODULE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        module: action.payload,
      };
    case ADD_MODULE_FAILURE:
    case GET_MODULES_BY_COURSE_ID_FAILURE:
    case UPDATE_MODULE_APPROVAL_STATUS_FAILURE:
    case GET_MODULE_BY_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case GET_MODULES_BY_COURSE_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        moduleListReponse: action.payload,
      };
    case GET_MODULE_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        moduleByIdResponse: action.payload,
      };
    case UPDATE_MODULE_APPROVAL_STATUS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        moduleApprovalStatusChangeResponse: action.payload,
      };
    case RESET_MODULE_APPROVAL_STATUS:
      return {
        ...state,
        moduleApprovalStatusChangeResponse: null,
      };
    case UPDATE_MODULE_ORDER_REQUEST:
      return {
        ...state,
        updateOrderLoading: true,
        updateOrderError: null,
      };
    case UPDATE_MODULE_ORDER_SUCCESS:
      return {
        ...state,
        updateOrderLoading: false,
        updateOrderError: null,
      };
    case UPDATE_MODULE_ORDER_FAILURE:
      return {
        ...state,
        updateOrderLoading: false,
        updateOrderError: action.payload,
      };
    case UPDATE_MODULE_REQUEST:
      return {
        ...state,
        updateModuleLoading: true,
        updateModuleError: null,
        updateModuleResult: null,
      };
    case UPDATE_MODULE_SUCCESS:
      return {
        ...state,
        updateModuleLoading: false,
        updateModuleError: null,
        updateModuleResult: action.payload,
      };
    case UPDATE_MODULE_FAILURE:
      return {
        ...state,
        updateModuleLoading: false,
        updateModuleError: action.payload,
        updateModuleResult: null,
      };
    case DELETE_MODULE_REQUEST:
      return {
        ...state,
        deleteModuleLoading: true,
        deleteModuleError: null,
        deleteModuleResult: null,
      };
    case DELETE_MODULE_SUCCESS:
      return {
        ...state,
        deleteModuleLoading: false,
        deleteModuleError: null,
        deleteModuleResult: action.payload,
      };
    case DELETE_MODULE_FAILURE:
      return {
        ...state,
        deleteModuleLoading: false,
        deleteModuleError: action.payload,
        deleteModuleResult: null,
      };
    default:
      return state;
  }
};
